<div class="bc-container">
  <div class="container-text bc-margin-2">
    <h1>{{ category }}</h1>
  </div>
  <div class="bc-row bc-justify-content-center">
    @for (sub of subCategories; track sub) {
      <div class="bc-col-3">
        <div
          bc-card
          class="bc-card-select bc-card bc-center"
          (click)="navigateToSubCategory(sub.url)"
          >
          <div class="bc-card-body container-text">
            <h4 class="bc-align-center">{{ sub.subCategory }}</h4>
          </div>
        </div>
      </div>
    }
  </div>
</div>
